var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                { attrs: { width: "100%" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "title",
                          attrs: { "align-baseline": "" }
                        },
                        [
                          _c("v-flex", { attrs: { xs2: "" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("commodityInfo")) + ": ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              !_vm.isCommodityUnchangeable
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { dark: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showCommodityEditPopup(
                                            {},
                                            "add"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("addCommodity")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.errorMessage
                            ? _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "red--text font-weight-bold text-xs-right"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errorMessage) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-2 mt-2",
                        attrs: {
                          headers: _vm.commodityHeaders,
                          items: _vm.value,
                          "hide-actions": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.scheduleBDescription) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.actionFrom === "eei"
                                        ? props.item.scheduleBCode || ""
                                        : props.item.harmonizedCode ||
                                            props.item.scheduleBCode
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.exportInformationCode) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.countryOfOrigin))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        props.item.licenseExceptionSymbol
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n                $" +
                                      _vm._s(
                                        props.item.customsValue.toLocaleString()
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.quantity2))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.commodityWeight))
                                ]),
                                _vm._v(" "),
                                !_vm.isCommodityUnchangeable ||
                                _vm.actionFrom === "createLabel"
                                  ? _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showCommodityEditPopup(
                                                  props,
                                                  "edit"
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.isCommodityUnchangeable
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteCommodity(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("FormSubmitPopup", {
                        attrs: {
                          title:
                            _vm.actionType === "add"
                              ? _vm.$t("addCommodity")
                              : _vm.$t("editCommodity"),
                          leftMethod: _vm.closeEditCommodityPopup,
                          rightMethod: _vm.onSubmit,
                          large: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _vm.actionFrom === "eei"
                                  ? [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  !(
                                                    _vm.isCommodityUnchangeable &&
                                                    _vm.actionFrom ===
                                                      "createLabel"
                                                  )
                                                    ? _c("v-select", {
                                                        staticStyle: {
                                                          "padding-top": "24px"
                                                        },
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "commonCommodity"
                                                          ),
                                                          items:
                                                            _vm.commonCommodities,
                                                          "item-text":
                                                            "description",
                                                          "item-value":
                                                            "description",
                                                          "return-object": ""
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.onSelectCommonCommodity
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commonCommodity,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.commonCommodity = $$v
                                                          },
                                                          expression:
                                                            "commonCommodity"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      attrs: {
                                                        "offset-y": "",
                                                        "close-on-content-click": false
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                !(
                                                                  _vm.isCommodityUnchangeable &&
                                                                  _vm.actionFrom ===
                                                                    "createLabel"
                                                                )
                                                                  ? _c(
                                                                      "v-text-field",
                                                                      {
                                                                        ref:
                                                                          "profile",
                                                                        attrs: {
                                                                          label: _vm.$t(
                                                                            "savedCommodity"
                                                                          ),
                                                                          "persistent-hint":
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return on.click.apply(
                                                                              null,
                                                                              arguments
                                                                            )
                                                                          },
                                                                          keyup: function(
                                                                            $event
                                                                          ) {
                                                                            if (
                                                                              !$event.type.indexOf(
                                                                                "key"
                                                                              ) &&
                                                                              _vm._k(
                                                                                $event.keyCode,
                                                                                "enter",
                                                                                13,
                                                                                $event.key,
                                                                                "Enter"
                                                                              )
                                                                            ) {
                                                                              return null
                                                                            }
                                                                            return _vm.getCommodities.apply(
                                                                              null,
                                                                              arguments
                                                                            )
                                                                          }
                                                                        },
                                                                        scopedSlots: _vm._u(
                                                                          [
                                                                            {
                                                                              key:
                                                                                "append",
                                                                              fn: function() {
                                                                                return [
                                                                                  _c(
                                                                                    "LoaderButton",
                                                                                    {
                                                                                      attrs: {
                                                                                        flat:
                                                                                          "",
                                                                                        isSmall:
                                                                                          "",
                                                                                        promiseAwait:
                                                                                          _vm.getCommodities,
                                                                                        buttonText: _vm.$t(
                                                                                          "search"
                                                                                        ),
                                                                                        disabled:
                                                                                          _vm.isCommodityUnchangeable &&
                                                                                          _vm.actionFrom ===
                                                                                            "createLabel"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              },
                                                                              proxy: true
                                                                            }
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                        model: {
                                                                          value:
                                                                            _vm.searchText,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.searchText = $$v
                                                                          },
                                                                          expression:
                                                                            "searchText"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        1506065791
                                                      ),
                                                      model: {
                                                        value: _vm.menuProfile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.menuProfile = $$v
                                                        },
                                                        expression:
                                                          "menuProfile"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _vm.searchedCommodities &&
                                                      _vm.searchedCommodities
                                                        .length
                                                        ? _c(
                                                            "v-list",
                                                            _vm._l(
                                                              _vm.searchedCommodities,
                                                              function(item) {
                                                                return _c(
                                                                  "v-list-tile",
                                                                  {
                                                                    key:
                                                                      item.requestId,
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return function() {
                                                                          return _vm.onSelectCommodity(
                                                                            item
                                                                          )
                                                                        }.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-tile-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-tile-title",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.profileName
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile-action",
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return function() {
                                                                                  return _vm.removeCommodityDb(
                                                                                    item
                                                                                  )
                                                                                }.apply(
                                                                                  null,
                                                                                  arguments
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "delete"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form",
                                              attrs: { "lazy-validation": "" }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "align-baseline": "",
                                                    "justify-space-between": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: _vm.$t(
                                                            "scheduleBDescription"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ]
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .scheduleBDescription,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "scheduleBDescription",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.scheduleBDescription"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _vm.isCreateFedex
                                                        ? [
                                                            _c("v-text-field", {
                                                              class:
                                                                "required_field",
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "hsCode"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldIsRequired(
                                                                    "hsCode"
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .commodityInEdit
                                                                    .harmonizedCode,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.commodityInEdit,
                                                                    "harmonizedCode",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "commodityInEdit.harmonizedCode"
                                                              }
                                                            })
                                                          ]
                                                        : [
                                                            _c("v-text-field", {
                                                              class:
                                                                "required_field",
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "scheduleBCode"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldIsRequired()
                                                                ],
                                                                disabled: !_vm.isScheduleBReady,
                                                                readonly:
                                                                  _vm.isCommodityUnchangeable &&
                                                                  _vm.actionFrom ===
                                                                    "createLabel"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .commodityInEdit
                                                                    .scheduleBCode,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.commodityInEdit,
                                                                    "scheduleBCode",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "commodityInEdit.scheduleBCode"
                                                              }
                                                            })
                                                          ]
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          items: [
                                                            {
                                                              text: _vm.$t(
                                                                "osAllOtherExports"
                                                              ),
                                                              value: "OS"
                                                            }
                                                          ],
                                                          "item-value": "value",
                                                          "item-text": "text",
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          label: _vm.$t(
                                                            "exportInformationCode"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .exportInformationCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "exportInformationCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.exportInformationCode"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          items: [
                                                            {
                                                              text: _vm.$t(
                                                                "c33NoLicenseRequired"
                                                              ),
                                                              value: "C33"
                                                            }
                                                          ],
                                                          "item-value": "value",
                                                          "item-text": "text",
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          label: _vm.$t(
                                                            "licenseExceptionSymbol"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .licenseExceptionSymbol,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "licenseExceptionSymbol",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.licenseExceptionSymbol"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "align-baseline": "",
                                                    "justify-space-between": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          items:
                                                            _vm.countryCodeArray,
                                                          "item-text": "name",
                                                          "item-value": "value",
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ],
                                                          label: _vm.$t(
                                                            "countryOfOrigin"
                                                          ),
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .countryOfOrigin,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "countryOfOrigin",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.countryOfOrigin"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: "ECCN",
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .eccn,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "eccn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.eccn"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: _vm.$t(
                                                            "totalCommodityWeight"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              "weight"
                                                            ),
                                                            _vm.fieldIsNoLessThanZero(
                                                              "weight"
                                                            ),
                                                            _vm.isMeasurementMetric
                                                              ? function() {
                                                                  return true
                                                                }
                                                              : _vm.fieldIsPkgWeight(
                                                                  false
                                                                )
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          suffix: _vm.isMeasurementMetric
                                                            ? "kg"
                                                            : "Lbs"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .commodityWeight,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "commodityWeight",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.commodityWeight"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          rules: [
                                                            _vm.fieldIsRequired(),
                                                            _vm.fieldIsNoLessThanZero()
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          label: _vm.$t(
                                                            "totalCustomsValue($)"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .customsValue,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "customsValue",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.customsValue"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "align-baseline": "",
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      staticClass:
                                                        "required_field qty_unit_filed",
                                                      attrs: {
                                                        "hide-details": "",
                                                        rules: [
                                                          _vm.fieldIsRequired(),
                                                          _vm.fieldIsInteger(),
                                                          _vm.fieldIsOverZero()
                                                        ],
                                                        label: _vm.$t(
                                                          "quantity"
                                                        ),
                                                        readonly:
                                                          _vm.isCommodityUnchangeable &&
                                                          _vm.actionFrom ===
                                                            "createLabel",
                                                        suffix: _vm.isUnitValid
                                                          ? _vm.qtySuffix
                                                          : ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.commodityInEdit
                                                            .quantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.commodityInEdit,
                                                            "quantity",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "commodityInEdit.quantity"
                                                      }
                                                    },
                                                    [
                                                      !_vm.isUnitValid
                                                        ? _c(
                                                            "template",
                                                            {
                                                              slot:
                                                                "append-outer"
                                                            },
                                                            [
                                                              _c("v-select", {
                                                                staticClass:
                                                                  "qty_unit",
                                                                attrs: {
                                                                  items:
                                                                    _vm.inShowChannelUnionList,
                                                                  "hide-details":
                                                                    "",
                                                                  clearable: "",
                                                                  "item-text":
                                                                    "text",
                                                                  "item-value":
                                                                    "key",
                                                                  label: _vm.$t(
                                                                    "unit"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .commodityInEdit
                                                                      .selectedUnit,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.commodityInEdit,
                                                                      "selectedUnit",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "commodityInEdit.selectedUnit"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [
                                                  _vm.isShowQty2
                                                    ? _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          rules: [
                                                            _vm.fieldIsRequired(),
                                                            _vm.fieldIsInteger(),
                                                            _vm.fieldIsOverZero()
                                                          ],
                                                          label: _vm.$t(
                                                            "quantity"
                                                          ),
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          suffix:
                                                            _vm.scheduleBMap[
                                                              _vm
                                                                .scheduleBCodeNormalized
                                                            ].uom1
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .quantity2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "quantity2",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.quantity2"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticStyle: {
                                                    "white-space": "nowrap"
                                                  },
                                                  attrs: { xs2: "" }
                                                },
                                                [
                                                  !_vm.isScheduleBReady
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("info")
                                                          ]),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "loadingScheduleB"
                                                              )
                                                            )
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-flex", {
                                                attrs: { xs2: "" }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-end": "",
                                                "align-baseline": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [
                                                  _vm.isSaveCommodityProfile
                                                    ? _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ],
                                                          label: _vm.$t(
                                                            "profileName"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .profileName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "profileName",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.profileName"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.actionType === "add"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass: "checkbox",
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "saveCommodityProfile"
                                                          ),
                                                          "hide-details": ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.isSaveCommodityProfile,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.isSaveCommodityProfile = $$v
                                                          },
                                                          expression:
                                                            "isSaveCommodityProfile"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  !(
                                                    _vm.isCommodityUnchangeable &&
                                                    _vm.actionFrom ===
                                                      "createLabel"
                                                  )
                                                    ? _c("v-select", {
                                                        staticStyle: {
                                                          "padding-top": "24px"
                                                        },
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "commonCommodity"
                                                          ),
                                                          items:
                                                            _vm.commonCommodities,
                                                          "item-text":
                                                            "description",
                                                          "item-value":
                                                            "description",
                                                          "return-object": ""
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.onSelectCommonCommodity
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commonCommodity,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.commonCommodity = $$v
                                                          },
                                                          expression:
                                                            "commonCommodity"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs4: "" } },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      attrs: {
                                                        "offset-y": "",
                                                        "close-on-content-click": false
                                                      },
                                                      scopedSlots: _vm._u([
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              !(
                                                                _vm.isCommodityUnchangeable &&
                                                                _vm.actionFrom ===
                                                                  "createLabel"
                                                              )
                                                                ? _c(
                                                                    "v-text-field",
                                                                    {
                                                                      ref:
                                                                        "profile",
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "savedCommodity"
                                                                        ),
                                                                        "persistent-hint":
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return on.click.apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        },
                                                                        keyup: function(
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "enter",
                                                                              13,
                                                                              $event.key,
                                                                              "Enter"
                                                                            )
                                                                          ) {
                                                                            return null
                                                                          }
                                                                          return _vm.getCommodities.apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        }
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "append",
                                                                            fn: function() {
                                                                              return [
                                                                                _c(
                                                                                  "LoaderButton",
                                                                                  {
                                                                                    attrs: {
                                                                                      flat:
                                                                                        "",
                                                                                      isSmall:
                                                                                        "",
                                                                                      promiseAwait:
                                                                                        _vm.getCommodities,
                                                                                      buttonText: _vm.$t(
                                                                                        "search"
                                                                                      ),
                                                                                      disabled:
                                                                                        _vm.isCommodityUnchangeable &&
                                                                                        _vm.actionFrom ===
                                                                                          "createLabel"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            },
                                                                            proxy: true
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                      model: {
                                                                        value:
                                                                          _vm.searchText,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.searchText = $$v
                                                                        },
                                                                        expression:
                                                                          "searchText"
                                                                      }
                                                                    }
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ]),
                                                      model: {
                                                        value: _vm.menuProfile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.menuProfile = $$v
                                                        },
                                                        expression:
                                                          "menuProfile"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _vm.searchedCommodities &&
                                                      _vm.searchedCommodities
                                                        .length
                                                        ? _c(
                                                            "v-list",
                                                            _vm._l(
                                                              _vm.searchedCommodities,
                                                              function(item) {
                                                                return _c(
                                                                  "v-list-tile",
                                                                  {
                                                                    key:
                                                                      item.requestId,
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return function() {
                                                                          return _vm.onSelectCommodity(
                                                                            item
                                                                          )
                                                                        }.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-tile-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-tile-title",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.profileName
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile-action",
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return function() {
                                                                                  return _vm.removeCommodityDb(
                                                                                    item
                                                                                  )
                                                                                }.apply(
                                                                                  null,
                                                                                  arguments
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "delete"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form",
                                              attrs: { "lazy-validation": "" }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    row: "",
                                                    wrap: "",
                                                    "mb-3": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs6: "" } },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs11: "",
                                                                "pr-3": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "required_field",
                                                                  attrs: {
                                                                    "hide-details":
                                                                      "",
                                                                    label: _vm.$t(
                                                                      "scheduleBDescription"
                                                                    ),
                                                                    rules: [
                                                                      _vm.fieldIsRequired()
                                                                    ]
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .commodityInEdit
                                                                        .scheduleBDescription,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.commodityInEdit,
                                                                        "scheduleBDescription",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "commodityInEdit.scheduleBDescription"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card",
                                                { attrs: { raised: "" } },
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c("h2", [
                                                            _vm._v(
                                                              "Invoice info"
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.isCreateUps
                                                        ? [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "align-baseline":
                                                                    "",
                                                                  "justify-space-between":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          items:
                                                                            _vm.countryCodeArray,
                                                                          "item-text":
                                                                            "name",
                                                                          "item-value":
                                                                            "value",
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "countryOfOrigin"
                                                                          ),
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .countryOfOrigin,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "countryOfOrigin",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.countryOfOrigin"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        class:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          label: _vm.$t(
                                                                            "hsCode"
                                                                          ),
                                                                          rules: [
                                                                            _vm.fieldIsRequired(
                                                                              _vm.$t(
                                                                                "hsCode"
                                                                              )
                                                                            )
                                                                          ]
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .harmonizedCode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "harmonizedCode",
                                                                              typeof $$v ===
                                                                                "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.harmonizedCode"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field qty_unit_filed",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          rules: [
                                                                            _vm.fieldIsRequired(),
                                                                            _vm.fieldIsInteger(),
                                                                            _vm.fieldIsOverZero()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "quantity"
                                                                          ),
                                                                          suffix: _vm.isHsCodeUnitValid
                                                                            ? _vm.hsCodeQtySuffix
                                                                            : ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .quantity2,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "quantity2",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.quantity2"
                                                                        }
                                                                      },
                                                                      [
                                                                        !_vm.isHsCodeUnitValid
                                                                          ? _c(
                                                                              "template",
                                                                              {
                                                                                slot:
                                                                                  "append-outer"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-select",
                                                                                  {
                                                                                    staticClass:
                                                                                      "qty_unit",
                                                                                    attrs: {
                                                                                      items:
                                                                                        _vm.upsHsCodeUnionList,
                                                                                      "hide-details":
                                                                                        "",
                                                                                      clearable:
                                                                                        "",
                                                                                      "item-text":
                                                                                        "text",
                                                                                      "item-value":
                                                                                        "key",
                                                                                      label: _vm.$t(
                                                                                        "unit"
                                                                                      )
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .commodityInEdit
                                                                                          .quantity2Units,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.commodityInEdit,
                                                                                          "quantity2Units",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "commodityInEdit.quantity2Units"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      2
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs2: ""
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        : [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "align-baseline":
                                                                    "",
                                                                  "justify-space-between":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          items:
                                                                            _vm.countryCodeArray,
                                                                          "item-text":
                                                                            "name",
                                                                          "item-value":
                                                                            "value",
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "countryOfOrigin"
                                                                          ),
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .countryOfOrigin,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "countryOfOrigin",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.countryOfOrigin"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          label: _vm.$t(
                                                                            "scheduleBDescription"
                                                                          ),
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ]
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .scheduleBDescription,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "scheduleBDescription",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.scheduleBDescription"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        class:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          label: _vm.$t(
                                                                            "hsCode"
                                                                          ),
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ]
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .scheduleBCode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "scheduleBCode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.scheduleBCode"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field qty_unit_filed pt-0",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          rules: [
                                                                            _vm.fieldIsRequired(),
                                                                            _vm.fieldIsInteger(),
                                                                            _vm.fieldIsOverZero()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "quantity"
                                                                          ),
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel",
                                                                          suffix: _vm.isUnitValid
                                                                            ? _vm.qtySuffix
                                                                            : ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .quantity,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "quantity",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.quantity"
                                                                        }
                                                                      },
                                                                      [
                                                                        !_vm.isUnitValid
                                                                          ? _c(
                                                                              "template",
                                                                              {
                                                                                slot:
                                                                                  "append-outer"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-select",
                                                                                  {
                                                                                    staticClass:
                                                                                      "qty_unit",
                                                                                    attrs: {
                                                                                      items:
                                                                                        _vm.inShowChannelUnionList,
                                                                                      "hide-details":
                                                                                        "",
                                                                                      clearable:
                                                                                        "",
                                                                                      "item-text":
                                                                                        "text",
                                                                                      "item-value":
                                                                                        "key",
                                                                                      label: _vm.$t(
                                                                                        "unit"
                                                                                      )
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .commodityInEdit
                                                                                          .selectedUnit,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.commodityInEdit,
                                                                                          "selectedUnit",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "commodityInEdit.selectedUnit"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      2
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs2: ""
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              (!!_vm.itn && _vm.isCreateUps) ||
                                              _vm.actionFrom === "eei"
                                                ? [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass: "mt-3",
                                                        attrs: { raised: "" }
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  row: "",
                                                                  wrap: "",
                                                                  "mb-3": ""
                                                                }
                                                              },
                                                              [
                                                                _c("h2", [
                                                                  _vm._v(
                                                                    "EEI info"
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "align-baseline":
                                                                    "",
                                                                  "justify-space-between":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        class:
                                                                          "required_field pt-0",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          label: _vm.$t(
                                                                            "scheduleBCode"
                                                                          ),
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ],
                                                                          disabled: !_vm.isScheduleBReady,
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .scheduleBCode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "scheduleBCode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.scheduleBCode"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "required_field qty_unit_filed pt-0",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          rules: [
                                                                            _vm.fieldIsRequired(),
                                                                            _vm.fieldIsInteger(),
                                                                            _vm.fieldIsOverZero()
                                                                          ],
                                                                          label: _vm.$t(
                                                                            "quantity"
                                                                          ),
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel",
                                                                          suffix: _vm.isUnitValid
                                                                            ? _vm.qtySuffix
                                                                            : ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .quantity,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "quantity",
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.quantity"
                                                                        }
                                                                      },
                                                                      [
                                                                        !_vm.isUnitValid
                                                                          ? _c(
                                                                              "template",
                                                                              {
                                                                                slot:
                                                                                  "append-outer"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-select",
                                                                                  {
                                                                                    staticClass:
                                                                                      "qty_unit",
                                                                                    attrs: {
                                                                                      items:
                                                                                        _vm.inShowChannelUnionList,
                                                                                      "hide-details":
                                                                                        "",
                                                                                      clearable:
                                                                                        "",
                                                                                      "item-text":
                                                                                        "text",
                                                                                      "item-value":
                                                                                        "key",
                                                                                      label: _vm.$t(
                                                                                        "unit"
                                                                                      )
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .commodityInEdit
                                                                                          .selectedUnit,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.commodityInEdit,
                                                                                          "selectedUnit",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "commodityInEdit.selectedUnit"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      2
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          items: [
                                                                            {
                                                                              text: _vm.$t(
                                                                                "osAllOtherExports"
                                                                              ),
                                                                              value:
                                                                                "OS"
                                                                            }
                                                                          ],
                                                                          "item-value":
                                                                            "value",
                                                                          "item-text":
                                                                            "text",
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ],
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel",
                                                                          label: _vm.$t(
                                                                            "exportInformationCode"
                                                                          )
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .exportInformationCode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "exportInformationCode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                  commodityInEdit.exportInformationCode\n                                "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "required_field",
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          items: [
                                                                            {
                                                                              text: _vm.$t(
                                                                                "c33NoLicenseRequired"
                                                                              ),
                                                                              value:
                                                                                "C33"
                                                                            }
                                                                          ],
                                                                          "item-value":
                                                                            "value",
                                                                          "item-text":
                                                                            "text",
                                                                          rules: [
                                                                            _vm.fieldIsRequired()
                                                                          ],
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel",
                                                                          label: _vm.$t(
                                                                            "licenseExceptionSymbol"
                                                                          )
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .licenseExceptionSymbol,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "licenseExceptionSymbol",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                  commodityInEdit.licenseExceptionSymbol\n                                "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "align-baseline":
                                                                    "",
                                                                  "justify-space-between":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs2: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          label:
                                                                            "ECCN",
                                                                          readonly:
                                                                            _vm.isCommodityUnchangeable &&
                                                                            _vm.actionFrom ===
                                                                              "createLabel"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .commodityInEdit
                                                                              .eccn,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.commodityInEdit,
                                                                              "eccn",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "commodityInEdit.eccn"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs2: ""
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs2: ""
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs2: ""
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "align-baseline": "",
                                                    "justify-space-between": "",
                                                    "mt-1": "",
                                                    "pl-3": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          rules: [
                                                            _vm.fieldIsRequired(),
                                                            _vm.fieldIsNoLessThanZero()
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          label: _vm.$t(
                                                            "totalCustomsValue($)"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .customsValue,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "customsValue",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.customsValue"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: _vm.$t(
                                                            "totalCommodityWeight"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              "weight"
                                                            ),
                                                            _vm.fieldIsNoLessThanZero(
                                                              "weight"
                                                            ),
                                                            _vm.isMeasurementMetric
                                                              ? function() {
                                                                  return true
                                                                }
                                                              : _vm.fieldIsPkgWeight(
                                                                  false
                                                                )
                                                          ],
                                                          readonly:
                                                            _vm.isCommodityUnchangeable &&
                                                            _vm.actionFrom ===
                                                              "createLabel",
                                                          suffix: _vm.isMeasurementMetric
                                                            ? "kg"
                                                            : "Lbs"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .commodityWeight,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "commodityWeight",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.commodityWeight"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-flex", {
                                                    attrs: { xs2: "" }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-flex", {
                                                    attrs: { xs2: "" }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "align-baseline": "",
                                                    "justify-space-between": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _vm.isShowQty2
                                                        ? _c("v-text-field", {
                                                            staticClass:
                                                              "required_field",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              rules: [
                                                                _vm.fieldIsRequired(),
                                                                _vm.fieldIsInteger(),
                                                                _vm.fieldIsOverZero()
                                                              ],
                                                              label: _vm.$t(
                                                                "quantity"
                                                              ),
                                                              readonly:
                                                                _vm.isCommodityUnchangeable &&
                                                                _vm.actionFrom ===
                                                                  "createLabel",
                                                              suffix:
                                                                _vm
                                                                  .scheduleBMap[
                                                                  _vm
                                                                    .scheduleBCodeNormalized
                                                                ].uom1
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .commodityInEdit
                                                                  .quantity2,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.commodityInEdit,
                                                                  "quantity2",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "commodityInEdit.quantity2"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        "white-space": "nowrap"
                                                      },
                                                      attrs: { xs2: "" }
                                                    },
                                                    [
                                                      !_vm.isScheduleBReady
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color: "red"
                                                                  }
                                                                },
                                                                [_vm._v("info")]
                                                              ),
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "loadingScheduleB"
                                                                  )
                                                                )
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-flex", {
                                                    attrs: { xs2: "" }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-end": "",
                                                "align-baseline": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [
                                                  _vm.isSaveCommodityProfile
                                                    ? _c("v-text-field", {
                                                        staticClass:
                                                          "required_field",
                                                        attrs: {
                                                          "hide-details": "",
                                                          rules: [
                                                            _vm.fieldIsRequired()
                                                          ],
                                                          label: _vm.$t(
                                                            "profileName"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.commodityInEdit
                                                              .profileName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.commodityInEdit,
                                                              "profileName",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "commodityInEdit.profileName"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.actionType === "add"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs2: "" } },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass: "checkbox",
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "saveCommodityProfile"
                                                          ),
                                                          "hide-details": ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.isSaveCommodityProfile,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.isSaveCommodityProfile = $$v
                                                          },
                                                          expression:
                                                            "isSaveCommodityProfile"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.isShowEditCommodityPopup,
                          callback: function($$v) {
                            _vm.isShowEditCommodityPopup = $$v
                          },
                          expression: "isShowEditCommodityPopup"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63ec8151", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ec8151","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommodityWidget.vue
// module id = null
// module chunks = 